/**
 * Creates an easing (out only) curve with a custom power (rather than using one
 * of the built ins, such as quad, quart and quint).
 *
 * Provides a great level of flexibility in terms of controlling the easing, but
 * comes at a cost of worse runtime performance - so whenever possible, prefer
 * using one of the defined curves.
 */
export function easeOut(t: number, power: number): number {
    return 1 - (t * -1 + 1) ** power;

}
